import { Divider, Link, Typography } from "@fullscript/aviary-web";
import { Trans, useTranslation } from "react-i18next";

import { sharedRoutes } from "@shared/data/sharedRoutes";
import { l } from "@shared/locales/i18n";
import { BackupCode } from "@shared/MultifactorAuthentication/components/legacy/BackupCode/BackupCode";

import * as styles from "./DisplayBackupCode.styles";

interface Props {
  backupCode: string;
  isModal?: boolean;
}

const DisplayBackupCode = ({ backupCode, isModal }: Props) => {
  const { t } = useTranslation();

  const renderTitle = () => {
    if (isModal) {
      return (
        <Typography variant="h4" intention="neutral" colorIntensity="bold">
          {t(l.mfa.displayBackupCode.title)}
        </Typography>
      );
    }

    return (
      <div css={styles.header}>
        <Typography variant="h1" intention="neutral" colorIntensity="bold">
          {t(l.mfa.displayBackupCode.title)}
        </Typography>
      </div>
    );
  };

  return (
    <>
      {renderTitle()}
      <Typography>
        <Trans
          i18nKey={l.mfa.displayBackupCode.enableComplete}
          components={{
            1: <Link href={sharedRoutes.external.loggingInWithATimeCode} />,
          }}
        />
      </Typography>
      <Divider customCss={styles.seperator} />
      <Typography fontWeight="bold" isMarginless>
        {t(l.mfa.displayBackupCode.important)}
      </Typography>
      <Typography>{t(l.mfa.displayBackupCode.backupCodeDescription)}</Typography>
      <BackupCode
        backupCode={backupCode}
        copyButtonTextOverride={t(l.mfa.displayBackupCode.copyBackupCode)}
      />
    </>
  );
};

export { DisplayBackupCode };
